import { render, staticRenderFns } from "./ProfilePicture.vue?vue&type=template&id=7f63c677&scoped=true"
import script from "./ProfilePicture.vue?vue&type=script&lang=ts"
export * from "./ProfilePicture.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f63c677",
  null
  
)

export default component.exports